<template>
    <div class="home">
     
      <TarifasVistaComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import TarifasVistaComponent from '@/components/TarifasVistaComponent.vue'
  
  export default {
    name: 'TarifasView',
    components: {
        TarifasVistaComponent
    }
  }
  </script>